"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M7.504 3.132l-7 4a1 1 0 000 1.736l7 4a1 1 0 00.992 0l7-4a1 1 0 000-1.736l-7-4a1 1 0 00-.992 0zM8 5.152L12.983 8 8 10.847 3.016 8 8 5.152z"];
//# sourceMappingURL=layer-outline.js.map